// Generated file. To retain edits, remove this comment.
import { getDefaultWebWorker as itkWasmGetDefaultWebWorker, createWebWorker } from 'itk-wasm';
import { getPipelineWorkerUrl } from './pipeline-worker-url.js';
let defaultWebWorker = null;
async function createNewWorker() {
    const pipelineWorkerUrl = getPipelineWorkerUrl();
    const pipelineWorkerUrlString = typeof pipelineWorkerUrl !== 'string' && typeof pipelineWorkerUrl?.href !== 'undefined' ? pipelineWorkerUrl.href : pipelineWorkerUrl;
    defaultWebWorker = await createWebWorker(pipelineWorkerUrlString);
}
export function setDefaultWebWorker(webWorker) {
    defaultWebWorker = webWorker;
}
export async function getDefaultWebWorker() {
    if (defaultWebWorker !== null) {
        if (defaultWebWorker.terminated) {
            await createNewWorker();
        }
        return defaultWebWorker;
    }
    const itkWasmDefaultWebWorker = itkWasmGetDefaultWebWorker();
    if (itkWasmDefaultWebWorker !== null) {
        return itkWasmDefaultWebWorker;
    }
    await createNewWorker();
    return defaultWebWorker;
}
//# sourceMappingURL=default-web-worker.js.map